import { render, staticRenderFns } from "./RmaParametrizacao.vue?vue&type=template&id=5a48b460&scoped=true"
import script from "./RmaParametrizacao.vue?vue&type=script&lang=js"
export * from "./RmaParametrizacao.vue?vue&type=script&lang=js"
import style0 from "./RmaParametrizacao.vue?vue&type=style&index=0&id=5a48b460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a48b460",
  null
  
)

export default component.exports